export default [{
	titulo: 'Secretarias',
	icone: 'menu-icon fa fa-caret-right',
	url: '/site/secretarias',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]